// Test IDs for the Spurs Finals Cash-In landing page
export const LANDING = {
  // Hero
  heroSection: "hero-section",
  urgencyBanner: "hero-urgency-banner",
  heroHeadline: "hero-headline",
  heroCta: "hero-cta-claim-finals-spot",
  // Goal
  goalSection: "goal-section",
  goalCardVisibility: "goal-card-visibility",
  goalCardCustomers: "goal-card-customers",
  goalCardSales: "goal-card-sales",
  goalCardRevenue: "goal-card-revenue",
  // Action Takers
  actionTakersSection: "action-takers-section",
  actionTakersCta: "action-takers-cta",
  // Who's Ready
  readyToWinSection: "ready-to-win-section",
  // Pricing
  pricingSection: "pricing-section",
  pricingCardStarter: "pricing-card-starter",
  pricingCardAllStar: "pricing-card-all-star",
  pricingCardChampionship: "pricing-card-championship",
  pricingCtaStarter: "pricing-cta-starter",
  pricingCtaAllStar: "pricing-cta-all-star",
  pricingCtaChampionship: "pricing-cta-championship",
  // Bonus
  bonusSection: "bonus-section",
  // Portfolio
  portfolioSection: "portfolio-section",
  portfolioTabWebsites: "portfolio-tab-websites",
  portfolioTabAds: "portfolio-tab-ads",
  portfolioTabPromotions: "portfolio-tab-promotions",
  // Founder
  founderSection: "founder-section",
  // Final CTA
  finalCtaSection: "final-cta-section",
  finalCta: "final-cta-button",
  // Footer
  footer: "site-footer",
  // Modal
  modalOverlay: "lead-capture-modal",
  modalNameInput: "lead-modal-name",
  modalEmailInput: "lead-modal-email",
  modalBusinessInput: "lead-modal-business",
  modalSubmit: "lead-modal-submit",
  modalClose: "lead-modal-close",
  modalError: "lead-modal-error",
  // Payment status
  paymentStatus: "payment-status-banner",
};
